import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Dialog } from '@app/components';

import {
  MarkasCompletedContainer,
  ChecklistButtonContainer,
  CancelButton,
  CompleteSavingIndicator,
  MarkValue,
  CompletedFooter,
} from '@app/modules/transaction-details/transactions-details-components';
import { ActivityLogInfo, ApproverDetails } from '@app/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '@app/styles';
import { useMarkasApproved } from '@app/graphql';

type Props = {
  onModalClose?: any;
  userInfo: any;
  approverDetails: ApproverDetails;
  setApproverDetails?: any;
  getActivityLogData: (e: ActivityLogInfo[]) => void;
  transactionCode: string;
  setTransactionStatus?: any;
};
let activityLog: ActivityLogInfo[] = [];

export default function MarkAsApprovedModal(props: Props) {
  const {
    onModalClose,
    userInfo,
    getActivityLogData,
    transactionCode,
    approverDetails,
    setApproverDetails,
    setTransactionStatus,
  } = props;
  const [submitMarkasApproved] = useMarkasApproved();
  const { transactionId }: any = useParams();
  const { firebaseId } = userInfo;
  const [saving, updatesaving] = React.useState<boolean>(false);
  const getActivityLog = () => {
    activityLog.push({
      transactionId: transactionId,
      firebaseId: firebaseId,
      item: transactionCode,
      description: 'has been marked as approved by ',
    });
    return activityLog;
  };
  const getApproveText = () => {
    if (saving) {
      return approverDetails.isApproved ? 'Unapproving' : 'Approving';
    }
    return approverDetails.isApproved ? 'Unapprove' : 'Approve';
  };
  const onSubmit = () => {
    updatesaving(true);
    const Variables = {
      isApproved: approverDetails.isApproved ? false : true,
      transactionId: transactionId,
      approvedBy: firebaseId,
      activityLog: getActivityLog(),
      status: approverDetails.isApproved ? 'COMPLETED' : 'APPROVED',
    };
    submitMarkasApproved({ variables: Variables })
      .then((res: any) => {
        if (res.data.markasApproved.success) {
          const {
            markasApproved: { transaction },
          } = res.data;
          setApproverDetails({
            isApproved: transaction.isApproved,
            approvedBy: transaction.approvedBy,
            approvedDate: transaction.approvedDate,
            approver: userInfo.firstName + ' ' + userInfo.lastName,
          });
          setTransactionStatus(transaction.status);
          const { activityLog = [] } = transaction;
          getActivityLogData(activityLog);
          updatesaving(false);
          onModalClose();
        }
      })
      .catch((error: any) => {});
  };
  return (
    <Dialog onClose={onModalClose} size="small">
      <MarkasCompletedContainer>
        <MarkValue>
          Are you sure you want to mark this transaction as {getApproveText()} ?
        </MarkValue>
        <CompletedFooter>
          {saving && (
            <CompleteSavingIndicator>
              <FontAwesomeIcon
                color={primaryColor}
                icon={faCircleNotch}
                size="lg"
                spin
              />
            </CompleteSavingIndicator>
          )}
          <CancelButton>
            <Button variant="text" size="medium" onClick={onModalClose}>
              Cancel
            </Button>
          </CancelButton>
          <ChecklistButtonContainer disabled={saving}>
            <Button
              variant="primary"
              size="medium"
              width="100%"
              type="submit"
              disabled={saving}
              onClick={onSubmit}>
              {getApproveText()}
            </Button>
          </ChecklistButtonContainer>
        </CompletedFooter>
      </MarkasCompletedContainer>
    </Dialog>
  );
}
